<div class="profile-container" *ngIf="auth.user$ | async as user">
    <div class="profile-header">
      <img
        [src]="user.picture"
        class="profile-picture"
      />
      <div class="profile-info">
        <h2>{{ user.name }}</h2>
        <p class="profile-email">{{ user.email }}</p>
      </div>
    </div>
  </div>
